import { Action } from '@ngrx/store';
import { LoadingAction } from '../../../shared/store/loading-store/loading-action.model';
import { LabAffiliation } from '../data/models/lab-affiliation.model';
import { ProgressAction } from '../../../../app/shared/store/progress-store/progress-action.model';
import { ActivityValidation } from '../data/models/activity-validation.model';

export enum ActionTypes {
    OPEN_CONFIRMATION_WINDOW = '[Claim CME/CE] Open Confirmation Window',
    CLOSE_CONFIRMATION_WINDOW = '[Claim CME/CE] Close Confirmation Window',

    OPEN_HELP_WINDOW = '[Claim CME/CE] Open Help Window',
    CLOSE_HELP_WINDOW = '[Claim CME/CE] Close Help Window',

    CLEAR_ERROR = '[Claim CME/CE] Clear Error',

    GET_CONTEXTUAL_HELP = '[Claim CME/CE] Get Contextual Help',
    GET_CONTEXTUAL_HELP_SUCCESS = '[Claim CME/CE] Get Contextual Help Success',
    GET_CONTEXTUAL_HELP_FAILURE = '[Claim CME/CE] Get Contextual Help Failure',

    GET_LAB_INFO = '[Claim CME/CE] Get Lab Info',
    GET_LAB_INFO_SUCCESS = '[Claim CME/CE] Get Lab Info Success',
    GET_LAB_INFO_FAILURE = '[Claim CME/CE] Get Lab Info Failure',

    GET_LAB_AFFILIATIONS = '[Claim CME/CE] Get Lab Affiliations',
    GET_LAB_AFFILIATIONS_SUCCESS = '[Claim CME/CE] Get Lab Affiliations Success',
    GET_LAB_AFFILIATIONS_FAILURE = '[Claim CME/CE] Get Lab Affiliations Failure',

    ASSIGN_KIT_TO_ACTIVITY = '[Claim CME/CE Assign Kit To Activity]',
    ASSIGN_KIT_TO_ACTIVITY_SUCCESS = '[Claim CME/CE Assign Kit To Activity Success]',
    ASSIGN_KIT_TO_ACTIVITY_FAILURE = '[Claim CME/CE Assign Kit To Activity Failure]',

    GET_ACTIVITY_REDIRECT_URL = '[Claim CME/CE] Get Activity Redirect Url',
    GET_ACTIVITY_REDIRECT_URL_SUCCESS = '[Claim CME/CE] Get Activity Redirect Url Success',
    GET_ACTIVITY_REDIRECT_URL_FAILURE = '[Claim CME/CE] Get Activity Redirect Url Failure',
}

//
// Confirmation Window
//
export class OpenConfirmationWindow implements Action {
    readonly type = ActionTypes.OPEN_CONFIRMATION_WINDOW;
}

export class CloseConfirmationWindow implements Action {
    readonly type = ActionTypes.CLOSE_CONFIRMATION_WINDOW;
}

//
// Help Window
//
export class OpenHelpWindow implements Action {
    readonly type = ActionTypes.OPEN_HELP_WINDOW;
}

export class CloseHelpWindow implements Action {
    readonly type = ActionTypes.CLOSE_HELP_WINDOW;
}

//
// Contextual Help
//
export class GetContextualHelp implements Action, LoadingAction {
    readonly type = ActionTypes.GET_CONTEXTUAL_HELP;

    loading = { add: ActionTypes.GET_CONTEXTUAL_HELP };
}

export class GetContextualHelpSuccess implements Action, LoadingAction {
    readonly type = ActionTypes.GET_CONTEXTUAL_HELP_SUCCESS;

    constructor(public payload: string) {}
    loading = { remove: ActionTypes.GET_CONTEXTUAL_HELP };
}

export class GetContextualHelpFailure implements Action, LoadingAction {
    readonly type = ActionTypes.GET_CONTEXTUAL_HELP_FAILURE;

    constructor(public payload: string) {}
    loading = { remove: ActionTypes.GET_CONTEXTUAL_HELP };
}

//
// Error
//

export class ClearError implements Action {
    readonly type = ActionTypes.CLEAR_ERROR;
}

//
// Lab Info
//
export class GetLabInfo implements Action, ProgressAction {
    readonly type = ActionTypes.GET_LAB_INFO;

    constructor(public payload: { capNumber: string }) {}

    progress = { add: ActionTypes.GET_LAB_INFO };
}

export class GetLabInfoSuccess implements Action, ProgressAction {
    readonly type = ActionTypes.GET_LAB_INFO_SUCCESS;

    constructor(public payload: LabAffiliation) {}

    progress = { remove: ActionTypes.GET_LAB_INFO };
}

export class GetLabInfoFailure implements Action, ProgressAction {
    readonly type = ActionTypes.GET_LAB_INFO_FAILURE;

    constructor(public payload: string) {}

    progress = { remove: ActionTypes.GET_LAB_INFO };
}

//
// Lab Affiliations
//
export class GetLabAffiliations implements Action, LoadingAction {
    readonly type = ActionTypes.GET_LAB_AFFILIATIONS;

    loading = { add: ActionTypes.GET_LAB_AFFILIATIONS };
}

export class GetLabAffiliationsSuccess implements Action, LoadingAction {
    readonly type = ActionTypes.GET_LAB_AFFILIATIONS_SUCCESS;

    constructor(public payload: LabAffiliation[]) {}

    loading = { remove: ActionTypes.GET_LAB_AFFILIATIONS };
}

export class GetLabAffiliationsFailure implements Action, LoadingAction {
    readonly type = ActionTypes.GET_LAB_AFFILIATIONS_FAILURE;

    constructor(public payload: string) {}

    loading = { remove: ActionTypes.GET_LAB_AFFILIATIONS };
}

//
// Assign Kit To Activity
//
export class AssignKitToActivity implements Action, ProgressAction {
    readonly type = ActionTypes.ASSIGN_KIT_TO_ACTIVITY;

    constructor(public payload: { orgNumber: string; kitNumber: string }) {}

    progress = { add: ActionTypes.ASSIGN_KIT_TO_ACTIVITY };
}

export class AssignKitToActivitySuccess implements Action, ProgressAction {
    readonly type = ActionTypes.ASSIGN_KIT_TO_ACTIVITY_SUCCESS;

    constructor(public payload: ActivityValidation) {}

    progress = { remove: ActionTypes.ASSIGN_KIT_TO_ACTIVITY };
}

export class AssignKitToActivityFailure implements Action, ProgressAction {
    readonly type = ActionTypes.ASSIGN_KIT_TO_ACTIVITY_FAILURE;

    constructor(public payload: any) {}

    progress = { remove: ActionTypes.ASSIGN_KIT_TO_ACTIVITY };
}

//
// Acitivty Redirect Url
//
export class GetActivityRedirectUrl implements Action, ProgressAction {
    readonly type = ActionTypes.GET_ACTIVITY_REDIRECT_URL;

    constructor(public payload: { activityCode: string }) {}

    progress = { add: ActionTypes.GET_ACTIVITY_REDIRECT_URL };
}

export class GetActivityRedirectUrlSuccess implements Action, ProgressAction {
    readonly type = ActionTypes.GET_ACTIVITY_REDIRECT_URL_SUCCESS;

    constructor(public payload: string) {}

    progress = { remove: ActionTypes.GET_ACTIVITY_REDIRECT_URL };
}

export class GetActivityRedirectUrlFailure implements Action, ProgressAction {
    readonly type = ActionTypes.GET_ACTIVITY_REDIRECT_URL_FAILURE;

    constructor(public payload: any) {}

    progress = { remove: ActionTypes.GET_ACTIVITY_REDIRECT_URL };
}

export type Actions =
    | OpenConfirmationWindow
    | CloseConfirmationWindow
    | OpenHelpWindow
    | CloseHelpWindow
    | GetContextualHelp
    | GetContextualHelpSuccess
    | GetContextualHelpFailure
    | ClearError
    | GetLabInfo
    | GetLabInfoSuccess
    | GetLabInfoFailure
    | GetLabAffiliations
    | GetLabAffiliationsSuccess
    | GetLabAffiliationsFailure
    | AssignKitToActivity
    | AssignKitToActivitySuccess
    | AssignKitToActivityFailure
    | GetActivityRedirectUrl
    | GetActivityRedirectUrlSuccess
    | GetActivityRedirectUrlFailure;
